import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  locationTypes: [],
  loading: false,
  error: null,
};

const getLocationTypeSlice = createSlice({
  name: "getLocationType",
  initialState,
  reducers: {
    fetchLocationTypeRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchLocationTypeSuccess: (state, action) => {
      state.loading = false;
      state.locationTypes = action.payload;
    },
    fetchLocationTypeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchLocationTypeRequest,
  fetchLocationTypeSuccess,
  fetchLocationTypeFailure,
} = getLocationTypeSlice.actions;

export default getLocationTypeSlice.reducer;